import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["visible", "message", "theme", "displayIcon", "icon"];
import React, { useEffect, useState } from 'react';
import { Wrapper, Text, WarningIcon } from './styles';
import withTheme from '../theme/withTheme';
var Tooltip = function Tooltip(_ref) {
  var visible = _ref.visible,
    message = _ref.message,
    theme = _ref.theme,
    displayIcon = _ref.displayIcon,
    Icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    className = _useState2[0],
    setClassName = _useState2[1];
  useEffect(function () {
    if (visible) {
      setClassName('jui--tooltip-visible');
    } else {
      setClassName('jui--tooltip-hidden');
    }
  }, [visible]);
  var _ref2 = /*#__PURE__*/React.createElement(WarningIcon, {
    theme: theme
  });
  var _ref3 = /*#__PURE__*/React.createElement(Icon, {
    theme: theme
  });
  function renderIcon() {
    switch (Icon) {
      case 'warning':
        return _ref2;
      default:
        return _ref3;
    }
  }
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: className,
    theme: theme,
    displayIcon: displayIcon
  }, rest), /*#__PURE__*/React.createElement(Text, {
    theme: theme
  }, displayIcon && renderIcon(), message));
};
Tooltip.defaultProps = {
  displayIcon: false
};
export default withTheme(Tooltip);